import { render, staticRenderFns } from "./RequirementAddEditQuailityRequeriments.vue?vue&type=template&id=70e692d2"
import script from "./RequirementAddEditQuailityRequeriments.vue?vue&type=script&lang=js"
export * from "./RequirementAddEditQuailityRequeriments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports